import type { ScheduleTRPCInput } from '@risksmart-app/trpc/src/types';
import { mapScheduleToTRPC } from '@risksmart-app/trpc/src/types';
import type {
  InsertChildRiskInput,
  InsertRiskMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  InsertRiskDocument,
  namedOperations,
} from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type InsertRiskTRPCInput = Omit<InsertChildRiskInput, 'schedule'> &
  ScheduleTRPCInput;

export const useInsertRisk = createMutationHook({
  name: 'insertRisk',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.risk.insert.mutationOptions({ onSuccess }),
  mapInput: ({
    schedule,
    ...rest
  }: InsertChildRiskInput): InsertRiskTRPCInput => ({
    ...rest,
    ...mapScheduleToTRPC(schedule),
  }),
  invalidate: (trpc) => [
    trpc.frontend.risk.register.queryKey(),
    trpc.frontend.risk.riskById.queryKey(),
    trpc.frontend.risk.scores.queryKey(),
    trpc.frontend.risk.riskListOnlyOptimized.queryKey(),
    trpc.frontend.risk.riskListOnlyWithEntitiesOptimized.queryKey(),
    trpc.frontend.risk.riskScoresByRiskId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): InsertRiskMutation => ({
    insertChildRisk: {
      __typename: 'IdOutput',
      Id: result.Id,
    },
  }),
  graphqlDocument: InsertRiskDocument,
  graphqlVariables: (input: InsertChildRiskInput) => ({ object: input }),
  evictFields: ['risk', 'risk_aggregate', 'risk_score'],
  refetchQueries: [
    namedOperations.Query.getRiskById,
    namedOperations.Query.getRisksByTier,
  ],
});
